import React from "react"; 
import { useCallback, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SearchUser() {

  const [input, setInput] = useState('');
  const [errorMessage, setErrorMessage] = useState(false);
  const API_key = process.env.REACT_APP_API_KEY;
  const navigate = useNavigate();

  // eslint-disable-next-line 
  const options = {
    method: 'GET',
    headers : {'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${API_key}`
              },
    mode: 'cors'
  };

  const getUser = useCallback(async () => {

    const routeChange = (data) => { 
      navigate('/user/' + data.login, {state: {user:data}} );
    };


    if(input) {
      const url = `https://api.github.com/users/${input}`;

      try {
        const result = await fetch(url);

        if(!result.ok) {
          setErrorMessage(true);
          throw new Error(`${result.statusText} (${result.status})`);
        }

        const data = await result.json();


        routeChange(data);
        setErrorMessage(false);

      } catch(error) {
        console.log(error.message);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input]);

  useEffect(() => {
      getUser();
  }, [getUser])


  const searchUser = (event) => {
    event.preventDefault();

    let username = event.target.username.value.trim().toLowerCase();
    setInput(username);
  };


    return (
      <main>
        <div className="search-page"> 
          <i className="fa-brands fa-github-alt"></i>
          <form onSubmit={searchUser}>
            <input type="text"
            autoComplete="off"
            name="username"
            placeholder="Search Github username..."
            />
            <input type="submit" value="Search"/>
          </form>
          <p className={`error-message ${errorMessage? 'is-visible' : ''}`}>User not found</p>
        </div>
      </main>
    );
}

export default SearchUser;